app.menu = {};
app.menu.close = function (callback) {
	var callback = callback || $.noop;

	if (app.dom.$page.hasClass('open-menu')) {
		app.dom.$page.removeClass('open-menu'); // Закрываем меню при переходе
		setTimeout(function () {
			callback();
		}, 400);
	} else {
		callback();
	}
}